import { useContext } from "react";
import { ChatConversationContext, type ChatConversationRuntime } from "./chatConversationContext";

export const useChatConversation = (): ChatConversationRuntime => {
    const context = useContext(ChatConversationContext);

    if (!context) {
        throw new Error("useChatConversation must be used within ChatConversationProvider.");
    }

    return context;
};
